import React, { Fragment, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import ShareModal from '../share/ShareModal';
import getParamsFromSearchURL from '../../utilities/getParamsFromSearchURL';
import { hasSlackFeature } from '../../utilities/featureHelper';
import { EVENTS } from '../../utilities/CONSTANTS';

const SharePageWrapper = ({ page, className = 'dropdown-option link', isPageShowView }) => {
    const menu = (window.hasSlack && hasSlackFeature()) ? 'Slack' : 'Email';
    const params = getParamsFromSearchURL(window.location.search);
    const { showFirstShareModal: isFirstShare, showSlackShareModal } = params;
    const showSlackModalInitial = isFirstShare || (showSlackShareModal && (showSlackShareModal == page.id));

    const [menuState, setMenuState] = useState(menu);
    const [isFirstShareState, setIsFirstShareState] = useState(isFirstShare);
    const [showSlackModal, setShowSlackModal] = useState(showSlackModalInitial);

    useEffect(() => {
        const clickShare = () => setShowSlackModal(true);
        window.addEventListener(EVENTS.SHOW_SHARE_MODAL, clickShare);

        return () => window.removeEventListener(EVENTS.SHOW_SHARE_MODAL, clickShare);
    }, []);

    const clickShare = () => setShowSlackModal(true);

    const extraClass = isPageShowView ? ' sm-hide' : '';

    return (
        <Fragment>
            <span className={className + extraClass} onClick={clickShare}>Share</span>
            {showSlackModal && page && createPortal(<ShareModal page={page} menu={menuState} isFirstShare={isFirstShareState} closeModal={() => setShowSlackModal(false)} />, document.body)}
        </Fragment>
    );
};

const SharePageButton = ({ className = 'dropdown-option' }) => {
    const onClickSharePage = (e) => window.dispatchEvent(new Event(EVENTS.SHOW_SHARE_MODAL));
    return (
        <span className={className} onClick={onClickSharePage}>Share</span>
    );
};

export { SharePageButton };

export default SharePageWrapper;
